import { ConstantsCodeType } from 'src/types/constantsCodes';
import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        type: 'number',
    },
    {
        label: 'createdAt',
        key: 'CREATED_AT',
        type: 'dateTime',
    },
    {
        label: 'title',
        key: 'TITLE',
    },
    {
        label: 'type',
        key: 'TYPE',
        type: 'select',
        selectOption: 'applicationMessageCodes',
        customRender: true,
        optionStyleFce: true,
    },
    {
        label: 'notificationType',
        key: 'NOTIFICATION_TYPE',
        type: 'select',
        selectOption: 'applicationMessageNotificationTypesCodes',
    },
    {
        label: 'active',
        key: 'ACTIVE',
        type: 'select',
        selectOption: 'boolNumberCodes',
        customRender: true,
    },
    {
        label: 'lang',
        key: 'LANG',
        type: 'select',
        selectOption: 'langCodes',
    },
];
